import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import * as XLSX from 'xlsx-js-style';
import { handleGetRequest } from '../../service/GetTemplate';
import { endPoints } from '../../Config';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { handlePostRequest } from '../../service/PostTemplate';

const QRReports = () => {
    const [report, setReport] = useState([]);
    const [paymentMethod, setPaymentMethod] = useState([]);
    const [loadingBtn, setLoadingBtn] = useState(false);

    const validationSchema = Yup.object().shape({
        fromDate: Yup.date().nullable(),

        toDate: Yup.date().when('fromDate', {
            is: (fromDate) => !!fromDate,
            then: Yup.date().required('Date To is required').min(Yup.ref('fromDate'), 'Date To has to be more than Date From')
        })
    });
    const dispatch = useDispatch();
    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            fromDate: '',
            toDate: '',
            issuer_Name: '',
            basket_Id: '',
            transaction_Currency: '',
            masked_Pan: ''
        },
        validate: (data) => {
            let errors = {};

            if (data.toDate && !data.fromDate) {
                errors.fromDate = 'Date From is required when Date To is provided';
            }

            if (data.fromDate && data.toDate && data.fromDate > data.toDate) {
                errors.toDate = 'Date To must be greater than or equal to Date From';
            }

            return errors;
        },
        onSubmit: async (data) => {
            setLoadingBtn(true);
            const addData = {
                fromDate: data.fromDate === '' ? null : data.fromDate,
                toDate: data.toDate === '' ? null : data.toDate,
                issuer_Name: data.issuer_Name === '' ? null : data.issuer_Name,
                basket_Id: data.basket_Id === '' ? null : data.basket_Id,
                transaction_Currency: data.transaction_Currency === '' ? null : data.transaction_Currency,
                masked_Pan: data.masked_Pan === '' ? null : data.masked_Pan
            };

            const response = await dispatch(handlePostRequest(addData, endPoints.searchMerchantQRReports, true));
            if (response?.status === 200) {
                setReport(response?.data?.data);
            }
            setLoadingBtn(false);
        }
    });
    const orderDateTemplate = (rowData) => {
        const isoDate = rowData?.order_Date;
        const date = new Date(isoDate);

        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();

        const formattedDate = `${dd}/${mm}/${yyyy}`;
        return <p>{formattedDate}</p>;
    };
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const previousDate = currentDate.toISOString().split('T')[0];
    const exportToExcel = () => {
        if (!report || report.length === 0) return;

        const exportData = report.map((item, index) => ({
            'Sr #': index + 1,
            'Basket ID': item.basket_Id,
            'Order Date': new Date(item.order_Date).toLocaleDateString(),
            'Amount': item.amount,
            'Transaction Currency': item.transaction_Currency,
            'Issuer Name': item.issuer_Name,
            'Masked Pan': item.masked_Pan
        }));

        const worksheetData = [['Sr #', 'Basket ID', 'Order Date', 'Amount', 'Transaction Currency', 'Issuer Name', 'Masked Pan'], ...exportData.map((obj) => Object.values(obj))];

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const headerRange = XLSX.utils.decode_range(worksheet['!ref']);
        for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
            if (!worksheet[cellAddress]) continue;
            worksheet[cellAddress].s = {
                font: { bold: true }
            };
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports');

        XLSX.writeFile(workbook, 'reports.xlsx');
    };
    const getPaymentList = async () => {
        const response = await handleGetRequest(endPoints.getDropdownPaymentMethod, true, false, dispatch);
        if (response) {
            setPaymentMethod(response?.data);
        }
    };

    useEffect(() => {
        getPaymentList();
    }, []);

    const handleReset = (e) => {
        e.preventDefault();
        formik.resetForm();
    };
    return (
        <div className="p-4">
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid grid mb-5">
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="roleName">From Date</label>
                                <InputText id="fromDate" type="date" name="fromDate" max={previousDate} value={formik?.values?.fromDate || ''} onChange={formik.handleChange} />

                                {formik.touched.fromDate && formik.errors.fromDate && <small className="p-error">{formik.errors.fromDate}</small>}
                            </div>
                        </div>
                        <div className="p-field col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="toDate"> TO Date </label>
                                <InputText id="toDate" type="date" name="toDate" max={previousDate} value={formik?.values?.toDate || ''} onChange={formik.handleChange} />

                                {formik.touched.toDate && formik.errors.toDate && <small className="p-error">{formik.errors.toDate}</small>}
                            </div>
                        </div>
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="phone">PAN</label>
                                <InputText id="masked_Pan" name="masked_Pan" keyfilter={'int'} placeholder="Enter PAN" maxLength={15} value={formik?.values?.masked_Pan} onChange={formik.handleChange} />
                                {formik.touched.phone && formik.errors.phone && <small className="p-error">{formik.errors.phone}</small>}
                            </div>
                        </div>
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="issuer_Name">Issuer Name</label>
                                <InputText id="issuer_Name" name="issuer_Name" placeholder="Enter Issuer Name " maxLength={50} value={formik?.values?.issuer_Name} onChange={formik.handleChange} />
                                {formik.touched.issuer_Name && formik.errors.issuer_Name && <small className="p-error">{formik.errors.issuer_Name}</small>}
                            </div>
                        </div>
                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="basket_Id">Basket ID</label>
                                <InputText id="basket_Id" name="basket_Id" placeholder="Enter Basket ID" maxLength={15} keyfilter={'int'} value={formik?.values?.basket_Id} onChange={formik.handleChange} />
                                {formik.touched.basket_Id && formik.errors.basket_Id && <small className="p-error">{formik.errors.basket_Id}</small>}
                            </div>
                        </div>

                        <div className="col-12 md:col-4">
                            <div className="p-field">
                                <label htmlFor="transaction_Currency">Currency</label>
                                <Dropdown
                                    id="transaction_Currency"
                                    name="transaction_Currency"
                                    value={formik?.values?.transaction_Currency}
                                    options={[]}
                                    optionLabel="name"
                                    optionValue="id"
                                    onChange={formik.handleChange}
                                    placeholder="Select Currency"
                                    className="w-full"
                                />
                                {formik.touched.transaction_Currency && formik.errors.transaction_Currency && <small className="p-error">{formik.errors.transaction_Currency}</small>}
                            </div>
                        </div>
                        <div className="live__SearchBtn p-field col-12 md:col-12">
                            <Button label="Search" icon="pi pi-search" className="Btn__Dark__Search" type="submit" />

                            <Button label="Reset" onClick={(e) => handleReset(e)} className="Btn__Transparent__Reset" />
                        </div>
                    </div>
                </form>
            </div>
            <div className="Form__Header mt-5 flex justify-content-between flex-wrap">
                <p className="text-2xl font-medium">QR Reports</p>
                <div className="flex align-items-center justify-content-center">
                    <Button className="mr-2" onClick={exportToExcel} disabled={!report || report.length === 0}>
                        Export To Excel
                    </Button>
                </div>
            </div>
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <DataTable
                            paginator
                            rows={15}
                            rowsPerPageOptions={[5, 10, 20]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                            emptyMessage="No List found."
                            responsiveLayout="scroll"
                            value={report}
                            className="p-datatable-sm datatable-responsive"
                        >
                            <Column field="basket_Id" header="Basket ID " />
                            <Column body={orderDateTemplate} header="Order Date" />
                            <Column field="amount" header="Amount" />
                            <Column field="transaction_Currency" header="Transaction Currency" />
                            <Column field="issuer_Name" header="Issuer Name" />
                            <Column field="masked_Pan" header="Masked Pan" />
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QRReports;
